/* eslint-disable-file @typescript-eslint/no-unused-vars */
import './Users.scss'
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { GoabBlock, GoabButton, GoabCheckbox, GoabCircularProgress, GoabDropdown, GoabDropdownItem,  GoabFormItem, GoabIcon, GoabIconButton,  GoabPagination, GoabSpacer, GoabTable, GoabTableSortHeader } from "@abgov/react-components"
import { GoabCalloutType, GoabCheckboxOnChangeDetail, GoabDropdownOnChangeDetail, GoabPaginationOnChangeDetail, GoabTableOnSortDetail, GoabTableSortDirection, GoabTemporaryNotificationType, TemporaryNotification } from '@abgov/ui-components-common';
import  {MultiSelect}  from "react-multi-select-component";
import { Link } from "react-router-dom";
import { UserInfo } from '../../common/models/userInfo'
import ApiService from "../../services/ApiService";
import { WdpTable }       from '../../components/wdpTable/WdpTable';
import { wdpUtil } from "../../common/utils/util";
import { useAuth } from 'react-oidc-context';
import { AppContext } from '../../contexts/apiContext';
import { GenListType, LookupItemType, UserFiltersInfo, UsersQueryParam } from '../../common/types';
import { IconButton, Tooltip } from '@mui/material';
import { RoleInfo, RolePlanInfo } from '../../common/models/roleInfo';
import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { CustomFmF } from '../../components/datePicker/datePicker';
import { parseToken } from '../../common/utils/tokenUtil';
import { createTableTestId } from '../../common/utils/testIds';
import { SearchBox } from '../../components/search/SearchBox';

const defSortDir: GoabTableSortDirection = 'asc'
const tableHeaders = [
  { text: "", name: ''  },
  { text: "Username (email)", name: 'email',  sortDir: defSortDir },
  { text: "First name", name: 'firstName'  },
  { text: "Middle name", name: 'middleName' },
  { text: "Last name", name: 'lastName' },
  { text: "Display name", name: 'displayName' },
  { text: "Organization", name: 'organization' },
  { text: "Username administered by", name: 'usernameAdministeredBy' },
  { text: "Local Government", name: 'localGovernment' },
  { text: "Access start date", name: 'accessStartDate' },
  { text: "Access end date", name: 'accessEndDate' },
  { text: "Phone", name: 'phone' },
  { text: "Status", name: 'userStatus' },
  { text: "Actions", name: '' }

];

const userStatusOptions: GenListType[] = [
  { label: 'Currently active',   value: 'active'      },
  { label: 'Currently inactive', value: 'inactive'    },
];
const tableHeadersRoles = [
    { text: "Roles",          name:'rolesTable_name',sortDir: defSortDir },
    { text: "Granted start (required)",  name:'rolesTable_grantedStart'},
    { text: "Granted end",    name:'rolesTable_grantedEnd'  },
    { text: "Actions",        name: '' },
  ];

const minSearchChars = 3;
export const Users = (props:any) => {
  
  // generic
  const hasMounted = useRef<boolean>(false);
  const [abortControllers, setAbortControllers] = useState<AbortController[]>([]);
  const [progressMsg, setProgressMsg] = useState("");
  
  // authentication object
  const auth = useAuth();
  
  // main dataset coming from the backend
  const [mainUsersList, setMainUsers] = useState(Array<UserInfo>);
  const mainUsersListCount = useRef(0);
  const previewUsersListCount = useRef(0);
  
  // sorting and pagination
  const sorting = useRef<{by:string,dir:GoabTableSortDirection}>({by:'email',dir:'asc'});
  const pageNo = useRef(0);  //"0 instead of 1" this is workaround  to fix pagination pageNo dropdown not being populate first time
  const perPage = useRef(20); 
  // granted-roles sub-table sort state, remembered so a reload (OnTRExpand/refreshUserRoles) reapplies the same order
  const rolesSorting = useRef<{by:string,dir:number}>({by:'name',dir:1});

  // Search and filters
  const searchStr = useRef('');
  const filters = useRef<UserFiltersInfo> ({localGov:[],userAdminBy:[],userWithRoles:[],userWithCurrentAccess:false,userStatuses:[{label:'Currently active',value:'active'}] });
  const [previewUsersList, setPreviewUsersList] = useState(Array<UserInfo>);
  
  // inPlace Row editing
  const [inPlaceEditUser,setInPlaceEditUser] = useState<UserInfo|undefined>();
  
  // inPlace Row editing for the granted roles sub-table - the role objects inside mainUsersList carry the shadow _granted* fields, this just tracks which row is being edited
  const [editingRoleId,setEditingRoleId] = useState<string|undefined>();
  
  // user Roles table (the subtable)
  const [showUserRolesRow, setShowUserRolesRow] = useState<boolean[]>([]);

  // context Data
  const myAppCtx = useContext(AppContext);
 
  /****************************************************************************************
  // Build Query
  ****************************************************************************************/

  function buildQueryParams():UsersQueryParam{
    
    const crit:Partial<UsersQueryParam>= {search:''};
    // search string
    crit.search = searchStr.current === ''?null:searchStr.current;
    // Filters
    const _incLocalGov          = filters.current.localGov;
    const _userAdminBy          = filters.current.userAdminBy;
    const _userWithRoles        = filters.current.userWithRoles;
    const _userWithCurrentAccess= filters.current.userWithCurrentAccess;
    const _userStatuses         = filters.current.userStatuses;
    crit.filter={
      localGov:               (_incLocalGov.length===0 || _incLocalGov.length === myAppCtx?.localGovsList.length) ? null:_incLocalGov.map(x => x.value),
      userAdminBy:            (_userAdminBy.length===0 || _userAdminBy.length === myAppCtx?.userAdminByList.length) ? null:_userAdminBy.map(x => x.label),
      userWithRoles:          (_userWithRoles.length===0 || _userWithRoles.length === myAppCtx?.allRolesList.length) ? null:_userWithRoles.map(x => x.value),
      userWithCurrentAccess:  _userWithCurrentAccess,
      userStatuses:           (_userStatuses.length===0 || _userStatuses.length === userStatusOptions.length) ? null : _userStatuses.map(x => x.value),
    };
    // pagination
    crit.paging={
      sortCol:sorting.current.by,
      sortDir:sorting.current.dir,
      pageNo:pageNo.current === 0 ? 1 : pageNo.current,
      perPage:perPage.current,
    };
    //console.log(JSON.stringify(crit));
    return crit as UsersQueryParam;
  }
  /****************************************************************************************
  // Load User call back function
  ****************************************************************************************/
  const loadUsers = useCallback((preview: boolean) =>{
    if(!preview){
      setProgressMsg("Loading users' information...");
    }
    // abort ongoing request
    abortControllers.forEach(controller => controller.abort());
    setAbortControllers([]);

    const queryParams = buildQueryParams();
    const controller = new AbortController();
    setAbortControllers([...abortControllers, controller]);
    
    ApiService.getFilteredUsers(auth.user?.access_token as string, queryParams,controller).then((res:any) => {
      if (res != null && res.rows != null && Array.isArray(res.rows)) {
        
        if (preview) {
          setPreviewUsersList(res.rows);
          //setShowPreview(true);
          previewUsersListCount.current = res.count;
        }
        else {
          mainUsersListCount.current = res.count;
          // save in the main list
          // some Extra initlization
          res.rows.forEach((userObj:UserInfo) => {
            userObj!.errors={accessStartDate:'',accessEndDate:''} ;
          }); 
          setMainUsers(res.rows);
          // save current page
          //setPageUsers(res.slice(0, perPage))
          //setShowPreview(false);
          //previewUsersListCount.current = -1; // close PreviewMode
          exitPreviewMode();
          const arr = [];
          for(let i=0;i<res.count;i++) arr[i]=false;
          setShowUserRolesRow(arr);
        }
      } else {
        //setShowPreview(false);
        //previewUsersListCount.current = -1; // close PreviewMode
        exitPreviewMode();
      }
    }).catch((error) => {
      console.log(error);
      setProgressMsg('');
    }).finally(() => {  setProgressMsg(''); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abortControllers, auth.user?.access_token]);

  /****************************************************************************************
   *  get the data from the backend On sorting and ,pagination
   * NOTE: in strect mode, react will trigger Componnet Mount event twice .. 
   * actually every event will be triggered twice
  /****************************************************************************************/
  useEffect(() => {
    if (hasMounted.current) return; // Skip if already mounted .. use this OLD with  first time  sideEffet ..empty array (componnent Mounted event)
    hasMounted.current = true;

    var promises:any[] = [];
    if(wdpUtil.isNullorUndefined(myAppCtx?.localGovsList) || myAppCtx?.localGovsList.length === 0){
      promises.push(ApiService.getLocalGovernments(auth.user?.access_token as string ));
    }else{
      promises.push(null);
    }
    if(wdpUtil.isNullorUndefined(myAppCtx?.allRolesList) || myAppCtx?.allRolesList.length === 0){
      promises.push(ApiService.getRoles(auth.user?.access_token as string ));
    }else{
      promises.push(null);
    }
    
    if(Promise.length){
      setProgressMsg('Loading local governments');
      Promise.all(promises).then(values => {
        if(promises[0] != null && values.length > 0 && values[0] != null){
          
            let Municipality = values[0];
            // get the localGovs
            myAppCtx?.setLocalGovsList(Municipality || []);
        }
        
        if(promises[1] != null && values.length > 0 && values[1] != null){
          // get roles
          const  roles =  values[1];
          myAppCtx?.setAllRolesList(roles);
        }
        
        // BUG: loading userList twice.
        // the following line is commented out on 2025/10-28.. 
        // table SortEvent will be trigged and there we will call loadusers
        // we must create/render the table with sorting enabled on one of the columns before loading the data
        // so, after the header got rendered, it will call sortDataUsers event listner and inside this listener ,we will load the data
        
        // ready to query users
        loadUsers(false);  
      
      }).catch((error) => {
      console.log(`Load local Government: ${error.message}`);
      setProgressMsg('');
      }).finally(() => {setProgressMsg('');});
    }else{
      // we already have the LocalGov  list loaded .. go ahead and query users
      setProgressMsg('');
      loadUsers(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**********************************************************************************
   * 
  ***********************************************************************************/
  function onFilterChange(who: String, value: any) {
    if(who==='fltr_localGov'){
      filters.current.localGov= value;
    }
    if(who==='fltr_userAdminBy'){
      filters.current.userAdminBy= value;
    }
    if(who==='fltr_userWithRoles'){
      filters.current.userWithRoles= value;
    }
    if(who==='fltr_userWithCurrentAccess'){
      filters.current.userWithCurrentAccess= value;
    }
    if(who==='fltr_userStatuses'){
      filters.current.userStatuses= value;
    }
    // Reload
    loadUsers(false);
  }
  /****************************************************************************************
  *  get the data from the backend On Searching
  /****************************************************************************************/
  function OnSearchChange(value:string){

    searchStr.current = value;
    if (searchStr.current.length === 0) {
      //setPreviewUsersList([]);
      //previewUsersListCount.current = -1; // close PreviewMode
      exitPreviewMode();
      //setShowPreview(false);
      // reset sorting and reload
      sorting.current = {by:'email',dir:'asc'}; 
      loadUsers(false);
      
    } else if ((searchStr.current.length < minSearchChars)) {
      //setPreviewUsersList([]);
      //previewUsersListCount.current=0;
      exitPreviewMode();
    } else if ((searchStr.current.length >= minSearchChars)) {
      pageNo.current = 1;
      loadUsers(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }
  /****************************************************************************************
   * styling after every rendering
  *****************************************************************************************/
  useEffect(() => {
    //  GoA styling 
    //let elem = document.getElementsByTagName getElementsByClassName('trailing-content')[0];
    // const page = document.getElementsByClassName('users-content')[0];
    // if (wdpUtil.isNullorUndefined(page))
    //   return;
    // var elems = page.querySelectorAll('[slot="trailingContent"]');
    // (elems[0] as HTMLElement).style.backgroundColor = 'transparent';// setAttribute("style","background-color:transparent");
    // (elems[0] as HTMLElement).style.borderWidth = '0px';
    // var wrap = searchWrap.current;
    // if (wrap !== undefined && wrap instanceof HTMLDivElement) {
    //   const w = wrap.clientWidth;
    //   // get search Inputfield position
    //   if (previewTableWrapElement.current) {
    //     if (previewTableWrapElement.current!.style.visibility === '' || previewTableWrapElement.current!.style.visibility === 'hidden') {
    //       //previewTableWrapElement.current!.style.left = `${Math.floor(wrap.clientLeft - 300)}px`;
    //       //previewTableWrapElement.current!.style.top = `${Math.floor(wrap.clientTop + 55)}px`;
    //       //previewTableWrapElement.current!.style.right = `0px`;
    //       //previewTableWrapElement.current!.style.bottom = `0px`;
    //       previewTableWrapElement.current!.style.width = `${Math.floor(w)}px`;
    //       previewTableWrapElement.current!.style.minWidth = `${Math.floor(w)}px`;
    //     }
    //   }
    //   //var inp = searchWrap.current.getElementsByTagName('goa-input')[0];
    // }
  });
  /****************************************************************************
   * 
   * @param newPage 
  ****************************************************************************/
  function OnPaginationChange(newPage: any) {
    // if (newPage >= 1) {
    //   const offset = (newPage - 1) * perPage;
    //   const _users = mainUsersList.slice(offset, offset + perPage)
    //   setPageNo(newPage);
    //   setPageUsers(_users);
    // }
    if (newPage >= 1) {
        //setPageNo(newPage);
        pageNo.current = newPage;
        loadUsers(false);
    }
  }
  /****************************************************************************
   * 
   * @param name 
   * @param value 
  ****************************************************************************/
  function changePerPage(name: any, value: any) {
    const newPerPage = parseInt(value, 10);
    // const offset = (pageNo - 1) * newPerPage;
    // const _users = mainUsersList.slice(offset, offset + newPerPage);
    // setPageUsers(_users);
    //setPerPage(newPerPage);
    if(newPerPage >=1){
      
      // reset page No .back to 1
      pageNo.current = 1;
      

      perPage.current = newPerPage;
      loadUsers(false);
    }
  }
  /**********************************************************************************
   * @param sortBy 
   * @param sortDir 
  ***********************************************************************************/
  function sortDataUsers(tableId:any,param: GoabTableOnSortDetail) {
    if(tableId !== 'usersTable'){
      return;
    }
    const sortBy: string=param.sortBy;
    const sortDir: number=param.sortDir;
    // ********************
    // NOTE: GoATable sortEvent goes to all table in the page. and this causing a big issue, becuase 
    // same event will go to User table and role table (the child table) 
    // as a workaround: added a prefix to the column name to filter sorting accordingly 
    // we are using the tableID to differentiate between tables SortEvent
    // ********************
    if(sortBy.includes("rolesTable")){
      return;
    }
    // exec the sorting
    sorting.current = {by:sortBy,dir:sortDir===1?"asc":"desc"};
    // reset page No .back to 1
    pageNo.current = 1;
    loadUsers(false);
    
    // this is for debugging
    //const debug = _users.map((item) => {return item?.lastName});
    //console.log(debug);
  }
  /**********************************************************************************
  when user click on the expand icon
  ***********************************************************************************/
  function OnTRExpand(userId:string,trIndex:number){
    
    const isOpening = showUserRolesRow[trIndex] !== true;
    // only one role sub-table open at a time: closing all others whenever one is toggled
    let showTracker = showUserRolesRow.map(() => false);
    // are we closing the subTable ?
    if(!isOpening){
      setShowUserRolesRow(showTracker);
      return;
    }
    showTracker[trIndex] = true;
    const userObj = mainUsersList.find((x)=> x.userId === userId);
    if(wdpUtil.isNullorUndefined(userObj)){
      console.log(`onTRExpand:Failed to find user for user Id (${userId})`);
      return;
    }
    //---------------------- 
    setProgressMsg("Loading user roles");
    refreshUserRoles(userId).then(() => {
      // ready to show the roles table
      setShowUserRolesRow(showTracker);
    }).catch(error => { console.log("load user roles:ERROR  " + error); })
    .finally(() => { setProgressMsg(''); });

  }
  /**********************************************************************************
   * (re)loads a single user's granted roles from the backend - shared by OnTRExpand (open row) and onSaveRoleRow (refresh after save)
  ***********************************************************************************/
  function refreshUserRoles(userId:string): Promise<void>{
    return ApiService.getRolePlans(auth.user?.access_token as string, userId).then((rolePlans: any[]) => {
        const goodList:RolePlanInfo[]=[];
        for(let r of rolePlans){
            const  found = myAppCtx?.allRolesList.find((rdef:any) => rdef.id=== r.roleId);
            if(wdpUtil.isNullorUndefined(found)){
              console.warn(`refreshUserRoles: no role definition found in allRolesList for roleId (${r.roleId}), plan id (${r.id}) - showing it anyway`);
            }
            const roleInfo: Partial<RolePlanInfo>={
              // keep all the plan fields from the backend (createdBy, createdOn, isRoleAdmin, isRoleOwner, etc.) so saving doesn't drop required fields
              ...r,
              id:r.id,
              roleId:r.roleId,
              userId:userId,
              // keep the raw (unformatted) values here - grantedEnd must stay null rather than '' or the backend rejects the save
              grantedStart: r.grantedStart,
              grantedEnd: r.grantedEnd
              ,name: found ? found!.name : `Unknown role (${r.roleId})`
              ,description: found ? found!.desc : undefined
              // shadow fields used for in-place editing, mirrors userRoles.tsx's pattern
              ,_grantedStart: r.grantedStart
              ,_grantedEnd: r.grantedEnd
              ,_grantedStartError: ''
              ,_grantedEndError: ''};
            goodList.push(roleInfo as RolePlanInfo);
        }
        const gr = wdpUtil.extractGrantedList(goodList);
        // reapply the remembered sort so the row order doesn't jump around after a reload
        const sortedGr = wdpUtil.sortData(rolesSorting.current.by, rolesSorting.current.dir, gr);
        const userObj = mainUsersList.find((x)=> x.userId === userId);
        if(!wdpUtil.isNullorUndefined(userObj)){
          userObj!.grantedRoles = [...sortedGr];
          setMainUsers([...mainUsersList]);
        }
      });
  }
  /**********************************************************************************
   * 
   * @param users 
   * @returns 
  ***********************************************************************************/
  function populatetableData(_users: any): any[] {
    if (wdpUtil.isNullorUndefined(_users) || !Array.isArray(_users) || _users.length === 0) {
      return []
    }
    return (
      _users.map((user, i) =>
        <React.Fragment key={user.userId+'-Fragment'}>
        <tr key={user.userId} id={user.userId}>
          <td className="col-flag"><GoabIconButton testId='tr_expand_btn' icon={showUserRolesRow[i]===false? 'chevron-forward':'chevron-down'} variant="color" size="small" onClick={function (): void { OnTRExpand(user.userId,i) }}></GoabIconButton></td>
          <td className="col-email"><Link to={`/user-ctrl/${user.userId}`}><span title={user.email || ''}>{user.email}</span></Link></td>
          <td className="col-firstName"><span title={user.firstName || ''}>{user.firstName}</span></td>
          <td className="col-middleName"><span title={user?.middleName || ''}>{user?.middleName}</span></td>
          <td className="col-lastName"><span title={user.lastName || ''}>{user.lastName}</span></td>
          <td className="col-displayName"><span title={user?.displayName || ''}>{user?.displayName}</span></td>
          <td className="col-organization"><span title={user?.organization || ''}>{user?.organization}</span></td>
          <td className="col-usernameAdministeredBy"><span title={user?.usernameAdministeredBy || ''}>{user?.usernameAdministeredBy}</span></td>
          <td className="col-localGovernment"><span title={user?.localGovernment || ''}>{user?.localGovernment}</span></td>
          {isEditable(user.userId) ? <td className='col-accessStartDate inPlaceEdit'>{populateDtRow('accessStartDate',user.userId)}</td> :<td className="col-accessStartDate"><span>{user?.accessStartDate ? dayjs(user.accessStartDate).tz().format('YYYY-MM-DD') : ""}</span></td>}
          {isEditable(user.userId) ? <td className='col-accessEndDate inPlaceEdit'>{populateDtRow('accessEndDate',user.userId)}  </td> :<td className="col-accessEndDate"><span>{user?.accessEndDate   ? dayjs(user.accessEndDate).tz().format('YYYY-MM-DD') : ""}</span></td>}
          <td className="col-phone"><span title={user?.phone || ''}>{user?.phone}</span></td>
          <td className="col-userStatus">{renderStatusBadge(user?.userStatus)}</td>
          <td className="col-actions action-col">
          {isEditable(user.userId) ? <div className='btn-saveCancel'><GoabButton testId='ul-save-row' type="secondary" size="compact" disabled={!isRowDirty()} onClick={() => {OnSaveRow(); (document.activeElement as HTMLElement)?.blur();}}>Save</GoabButton><GoabButton testId='ul-cancel-row' type="secondary" size="compact" onClick={() => {OnCancelRow()}}>Cancel</GoabButton></div>
          :
          <div className='btn-edit'><GoabButton testId='ul-edit-row' type="tertiary" size="compact" disabled={editingRoleId !== undefined} onClick={() => {onEditRow(user.userId)}}>Edit</GoabButton></div>
          }
          </td>
        </tr>
        {(showUserRolesRow[i]===true) && 
          <tr>
            <td className="col-flag"></td>
            <td id={`roles-container-${user.userId}`} colSpan={tableHeaders.length - 1} className='td-roles-container role-table-grid-template'>
              <WdpTable testId='row_rolesTable' id="rolesTable" resize={false} tableHeaders={tableHeadersRoles} populatetableData={()=> populateTableDataRoles(user?.userId)} sortDataFunc={(tableId:any,param: GoabTableOnSortDetail)=>sortDataRoles(user.userId, tableId,param)}/>
            </td>
          </tr>}
        </React.Fragment>

      )
    );
  }
  /**********************************************************************************
  ***********************************************************************************/
  function populateTableDataRoles(userId:string):any[]{
    // find the current user in the User List
    const userObj = mainUsersList.find((x)=> x.userId === userId);
    const gr = userObj?.grantedRoles;
    if (wdpUtil.isNullorUndefined(userObj) || wdpUtil.isNullorUndefined(gr) || !Array.isArray(gr) || gr.length === 0) {
      return []
    }
    return (
      gr.map((role, i) =>
        <tr key={role.roleId} id={role.roleId}>
          <td >
            <div className='roleNameCol'>
              <span className='ellipsis-text' title={role.name}>{role.name}</span>
              <span>
                <Tooltip title={role.description} placement='top' arrow>
                  <IconButton size="small">
                      <GoabIcon size="small" fillColor='var(--goa-color-interactive-default)' type="information-circle"></GoabIcon>  
                  </IconButton>
                </Tooltip>
              </span>
            </div>
            
          </td>
          <td>{isRoleEditable(role.roleId) ? <div className='inPlaceEdit'>{populateRoleDtCol('grantedStart', role)}</div> : <span className='ellipsis-text' title={role.grantedStart ? dayjs(role.grantedStart).tz().format('YYYY-MM-DD') : ''}>{role.grantedStart ? dayjs(role.grantedStart).tz().format('YYYY-MM-DD') : ''}</span>}</td>
          <td>{isRoleEditable(role.roleId) ? <div className='inPlaceEdit'>{populateRoleDtCol('grantedEnd', role)}</div>   : <span className='ellipsis-text' title={role.grantedEnd ? dayjs(role.grantedEnd).tz().format('YYYY-MM-DD') : ''}>{role.grantedEnd ? dayjs(role.grantedEnd).tz().format('YYYY-MM-DD') : ''}</span>}</td>
          <td className="action-col">
          {isRoleEditable(role.roleId) ? <div className='btn-saveCancel'><GoabButton testId='ur-save-role-row' type="secondary" size="compact" disabled={!isRoleRowDirty(role)} onClick={() => {onSaveRoleRow(role); (document.activeElement as HTMLElement)?.blur();}}>Save</GoabButton><GoabButton testId='ur-cancel-role-row' type="secondary" size="compact" onClick={() => {onCancelRoleRow()}}>Cancel</GoabButton></div>
          :
          <div className='btn-edit'><GoabButton testId='ur-edit-role-row' type="tertiary" size="compact" disabled={inPlaceEditUser !== undefined} onClick={() => {onEditRoleRow(role)}}>Edit</GoabButton></div>
          }
          </td>
        </tr>
      )
    );
  }
  /**********************************************************************************
  ***********************************************************************************/
  function isRoleEditable(roleId:string):boolean{
    return editingRoleId === roleId;
  }
  /**********************************************************************************
  ***********************************************************************************/
  function isRoleRowDirty(role:RolePlanInfo):boolean{
    return wdpUtil.isRoleUpdated(role);
  }
  /**********************************************************************************
  ***********************************************************************************/
  function onEditRoleRow(role: RolePlanInfo){
    // block starting a role-row edit while the parent user row is already being edited
    if(!wdpUtil.isNullorUndefined(inPlaceEditUser)){
      return;
    }
    setEditingRoleId(role.roleId);
  }
  /**********************************************************************************
   * finds the (mutable) granted role object living inside a users list
  ***********************************************************************************/
  function findGrantedRole(userId:string|undefined, roleId:string|undefined, list:UserInfo[]):RolePlanInfo|undefined{
    const userObj = list.find((u: UserInfo) => u.userId === userId);
    return userObj?.grantedRoles.find((r: RolePlanInfo) => r.roleId === roleId);
  }
  /**********************************************************************************
  ***********************************************************************************/
  function onCancelRoleRow(){
    const _mainUsersList = [...mainUsersList];
    const userObj = _mainUsersList.find((u: UserInfo) => u.grantedRoles.some((r: RolePlanInfo) => r.roleId === editingRoleId));
    const role = userObj?.grantedRoles.find((r: RolePlanInfo) => r.roleId === editingRoleId);
    if(role){
      // discard the shadow edits, back to the committed values
      role._grantedStart = role.grantedStart;
      role._grantedEnd = role.grantedEnd;
      role._grantedStartError = '';
      role._grantedEndError = '';
      setMainUsers(_mainUsersList);
    }
    setEditingRoleId(undefined);
  }
  /**********************************************************************************
  ***********************************************************************************/
  function onSaveRoleRow(role: RolePlanInfo){

    const _mainUsersList = [...mainUsersList];
    const roleObj = findGrantedRole(role.userId, role.roleId, _mainUsersList);
    if(wdpUtil.isNullorUndefined(roleObj)){
      return;
    }
    // validate using the same rules as the granted-roles list in userRoles.tsx
    roleObj!._grantedStartError = wdpUtil.isRoleDatesValid(roleObj!, 'granted.grantedStart');
    roleObj!._grantedEndError   = wdpUtil.isRoleDatesValid(roleObj!, 'granted.grantedEnd');
    if(roleObj!._grantedStartError !== '' || roleObj!._grantedEndError !== ''){
      // show the errors inline and stay in edit mode
      setMainUsers(_mainUsersList);
      return;
    }

    // build the payload from the shadow edits - don't touch the rendered/committed values until the backend confirms the save
    const payload = wdpUtil.deepCopy(roleObj) as RolePlanInfo;
    payload.updatedBy    = parseToken(auth.user?.id_token as string)?.name;
    payload.updatedOn    = dayjs().tz().toISOString();
    payload.grantedStart = roleObj!._grantedStart!;
    payload.grantedEnd   = roleObj!._grantedEnd;

    submitRoleRow(payload, role.userId);
  }
  /**********************************************************************************
  ***********************************************************************************/
  function submitRoleRow(roleObj:RolePlanInfo, userId:string) {
    setProgressMsg("Update role granted dates");
    ApiService.updateRolePlans(auth.user?.access_token as string, [roleObj]).then((res) => {
      handleToastOpen("Role updated successfully");
      // pull the committed values back from the backend; showUserRolesRow is untouched so the row stays expanded
      return refreshUserRoles(userId);
    }).then(() => {
      setEditingRoleId(undefined);
    }).catch((error) => {
      console.log(error);
      // stay in edit mode so the user can retry - local shadow values are untouched
      handleToastOpen(`failed to update role. ${error?.response?.data}`, "emergency");
    }).finally(() => { setProgressMsg(""); });
  }
  /**********************************************************************************
  ***********************************************************************************/
  function populateRoleDtCol(fieldName: 'grantedStart'|'grantedEnd', role: RolePlanInfo) {

    const dtError  = fieldName === 'grantedStart' ? role._grantedStartError : role._grantedEndError;
    const dt       = fieldName === 'grantedStart' ? role._grantedStart : role._grantedEnd;
    const aDt      = (dt ? dayjs(dt).tz() : null);
    return (
      <div className={dtError ? 'dt-field dt-field-with-error' : 'dt-field'}>
        <CustomFmF name={fieldName}
          value={aDt}
          onChange={(event: any) => onChangeRoleRow(fieldName, event, role)}
          error={dtError}
        />
        {dtError && <div className="validation-error-txt" title={dtError}><GoabIcon type="warning" fillColor="red" theme="filled" size="small" />{dtError}</div>}
      </div>
    );
  }
  /**********************************************************************************
  ***********************************************************************************/
  function onChangeRoleRow(fldName:'grantedStart'|'grantedEnd', e:any, role: RolePlanInfo):void{

    const _mainUsersList = [...mainUsersList];
    const roleObj = findGrantedRole(role.userId, role.roleId, _mainUsersList);
    if(wdpUtil.isNullorUndefined(roleObj)){
      return;
    }

    let asDj: Dayjs|null = e.target.value;
    if(!wdpUtil.isNullorUndefined(asDj) && asDj!==null && (!isNaN(asDj.toDate().getTime()))){
      asDj = (fldName === 'grantedStart') ? dayjs.utc(asDj.tz().startOf('day')) : dayjs.utc(asDj.tz().endOf('day'));
    }else{
      // invalid (non-null) date - don't let an Invalid Date ever reach toISOString()
      asDj = null;
      console.log("not valid date");
    }

    if(fldName === 'grantedStart'){
      roleObj!._grantedStart = asDj?asDj.toISOString():null;
      // you can't have an end date if the start date is cleared
      if(asDj === null){
        roleObj!._grantedEnd = null;
      }
      roleObj!._grantedStartError = '';
    }
    if(fldName === 'grantedEnd'){
      roleObj!._grantedEnd = asDj?asDj.toISOString():null;
      roleObj!._grantedEndError = '';
    }

    setMainUsers(_mainUsersList);
  }
  /**********************************************************************************
   * 
  ***********************************************************************************/
  function sortDataRoles(userId:string,tableId:any,param: GoabTableOnSortDetail) {
    if(tableId !== 'rolesTable'){
      return;
    }
    // sorting params
    const sortBy: string=param.sortBy;
    const sortDir: number=param.sortDir;

    //find the user
    const newMainUsersList = [...mainUsersList];
    const userObj = newMainUsersList.find((x)=> x.userId === userId);
    if(wdpUtil.isNullorUndefined(userObj)){
      console.log(`sortData:Failed to find user for user Id (${userId})`);
      return;
    }
    //remove tablename prefix
    const goodSortBy = sortBy.split('_');
    if(goodSortBy==null || goodSortBy.length !== 2){
      return;
    }
    // remember it so a subsequent reload (save/expand) reapplies the same order
    rolesSorting.current = {by:goodSortBy[1], dir:sortDir};
    // exec the sorting
    const _roles = wdpUtil.sortData(goodSortBy[1], sortDir, userObj?.grantedRoles);
    // update the list
    userObj!.grantedRoles = [..._roles];
    setMainUsers(newMainUsersList);
  }
  /**********************************************************************************
   * 
  ***********************************************************************************/
  function populatePreviewtableData(): any[] {
    if (wdpUtil.isNullorUndefined(previewUsersList) || !Array.isArray(previewUsersList) || previewUsersList.length === 0) {
      return []
    }
    return (
      previewUsersList.map((user, i) =>
        <tr key={user.userId}>
          <td><Link to={`/user-ctrl/${user.userId}`}><span>{user.email}</span></Link></td>
          <td><span>{user.firstName} {user?.middleName} {user.lastName}</span></td>

        </tr>
      )
    );
  }
  /***************************************************************************************
   * 
   * @param name 
   * @param value 
   **************************************************************************************/
  function onSearchInputChange(name: string, value: string) {
    // event without a change in the content (special characters, arrows, ...)
    if (searchStr.current === value) {
      return;
    }
    OnSearchChange(value);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onSearchBtn() {
    // take a copy
    //const temp = wdpUtil.deepCopy(previewUsersList);
    //setMainUsers(temp);
    //setPreviewUsersList([]);
    //previewUsersListCount.current = -1; // close PreviewMode
    exitPreviewMode();
    //setShowPreview(false);
    loadUsers(false);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onCloseSearchBtn() {
    exitPreviewMode();
    //setShowPreview(false);
    // loadUsers("", false);
    OnSearchChange('');
  }
  function exitPreviewMode(){
    
    setPreviewUsersList([]);
    previewUsersListCount.current = -1;
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function populateSearchResTitle() {

    return (<div className='h3'>{previewUsersListCount.current === -1? mainUsersListCount.current:previewUsersListCount.current} records found </div>);

    // if (searchStr && searchStr.current.length >= minSearchChars && !isLoading) {
    //   // search preview visible ?
    //   return (<div className='h3'>{previewUsersListCount.current === -1? mainUsersListCount.current:previewUsersListCount.current} result for '{searchStr.current}'</div>);
    //   /*}
    //   else{
    //     // we close the and reset the search preview (user clicked on the searech icon or hit enter)
    //     return (<div className='h3'>{mainUsersList?.length} result for '{searchStr}'</div>);
    //   }*/
    // }
    // else {
    //   return (<div></div>);
    // }
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function populateDropDown(label:string,id:string,who:GenListType[],options:any){
    
    //const keyTypedVal   = who as typeof GenListType[];
    return (
    <GoabFormItem label={label} id={id}>
      <MultiSelect data-testid={id} className='multiSel-filter' closeOnChangedValue={false} 
        options={options }
        value={who}
        onChange={(e: any) => onFilterChange(id, e)} 
        labelledBy="--Select--"
      />
    </GoabFormItem>
    );
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onClearAll(){
    filters.current.localGov = [];
    filters.current.userAdminBy = [];
    filters.current.userWithRoles = [];
    filters.current.userWithCurrentAccess = false;
    filters.current.userStatuses = [{label:'Currently active',value:'active'}];
    searchStr.current = "";
    setProgressMsg(''); // this is just to force Rerender
    // Reload
    loadUsers(false);

  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function isEditable(userId:string):boolean{
    return !wdpUtil.isNullorUndefined(inPlaceEditUser) && (inPlaceEditUser!.userId === userId);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function isRowDirty():boolean{
    
    if(!wdpUtil.isNullorUndefined(inPlaceEditUser)){
      const savedInfo = mainUsersList.find((u: UserInfo) => u.userId === inPlaceEditUser?.userId);
      if(!wdpUtil.isNullorUndefined(savedInfo)){
        return (inPlaceEditUser?.accessStartDate !== savedInfo?.accessStartDate  || inPlaceEditUser?.accessEndDate !== savedInfo?.accessEndDate);
      }
    }
    return false;
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onEditRow(userId:string){
    // block starting a parent-row edit while a granted-role row is already being edited
    if(editingRoleId !== undefined){
      return;
    }
    const userObj:UserInfo|undefined = mainUsersList.find((x)=> x.userId === userId);
    if(wdpUtil.isNullorUndefined(userObj)){
      console.log(`Failed to find user for user Id (${userId})`);
      return;
    }
    setInPlaceEditUser(userObj);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function OnCancelRow(){
  
    setInPlaceEditUser(undefined);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function OnSaveRow(){
    
    const userObj = inPlaceEditUser; //easy access 
    let asDtError = '';
    let aeDtError = '';
    // do the validation
    // what was the change ?
    const savedInfo = mainUsersList.find((u: UserInfo) => u.userId === userObj?.userId);
    if(!wdpUtil.isNullorUndefined(savedInfo)){
      if(savedInfo?.accessStartDate !== userObj?.accessStartDate){
        asDtError = wdpUtil.validateStartDate (userObj?.accessStartDate?.toString(),userObj?.accessEndDate?.toString());    
      }
      if(savedInfo?.accessEndDate !== userObj?.accessEndDate){
        aeDtError   = wdpUtil.validateEndDate (userObj?.accessStartDate?.toString(),userObj?.accessEndDate?.toString());
      }
    }
    // dowe have any vlidation error?
    if(!wdpUtil.isNullorUndefined(asDtError) && asDtError !== ''){
      handleToastOpen(`${asDtError}`, "emergency");
      return;
    }
    if(!wdpUtil.isNullorUndefined(aeDtError) && aeDtError !== ''){
      handleToastOpen(`${aeDtError}`, "emergency");
      return;
    }

    // exec save
    const _mainUsersList = [...mainUsersList];
    const index = _mainUsersList.findIndex((u: UserInfo) => u.userId === userObj?.userId);
    if(index !==-1){
      // update the list and dont refresh to avoid Page-flickering. but 4 sure the data in the list is same as the data in the DB
      _mainUsersList[index] = wdpUtil.deepCopy(userObj);
      setMainUsers(_mainUsersList);
      
      // submit to DB
      submitRow(userObj!.userId,userObj!);
    }
    // exit edit mode for this user
    OnCancelRow();
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function submitRow(userId:string,userObj:UserInfo) {
    
    //userObj.accessEndDate = (wdpUtil.isNullorUndefined(userObj.accessEndDate) || userObj.accessEndDate!.length === 0) ? null : userObj.accessEndDate;
    setProgressMsg("Update user access date");
    ApiService.updateUser(auth.user?.access_token as string, userId as string, userObj).then(res => {
        handleToastOpen("User updated successfully");
    }).catch((error) => {
        setProgressMsg("");  
        console.log(error);
        handleToastOpen(`failed to update user. ${error?.response?.data}`, "emergency");
    }).finally(() => { setProgressMsg("");  });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function populateDtRow(fieldName: string,userId:string) {
    
    //rendering part
    const userObj = inPlaceEditUser; //easy access 
    const dtError = (fieldName === "accessStartDate") ? userObj?.errors.accessStartDate : userObj?.errors.accessEndDate;
    const dt      = fieldName === "accessStartDate" ? userObj?.accessStartDate: userObj?.accessEndDate;
    const dtStr   =  dt;//  !wdpUtil.isNullorUndefined(dt)? dayjs.utc(dayjs(dt).tz().startOf('day')).toISOString() : '';
    
    const aDt     = (dtStr ? dayjs(dtStr).tz() : null);
    return (
      <>
        <CustomFmF name={fieldName}
          value={aDt}
          onChange={(event: any) => onChangeRow(fieldName,event)}
          //onBlur={(event: any) => onBlurRow(event)}
          error={dtError}
        />
        {/* {dtError!=='' && <section className="error"><GoabIcon type="warning" theme="filled" size="small" /><span > {dtError}</span></section>} */}
      </>
      );
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onChangeRow(fldName:string,e:any):void{
      
    const userObj = {...inPlaceEditUser};

    let asDj: Dayjs|null = e.target.value;
    
    if( !wdpUtil.isNullorUndefined(asDj) && asDj!==null && (!isNaN(asDj.toDate().getTime()))){
      asDj  = (fldName === 'accessStartDate') ? dayjs.utc(asDj.tz().startOf('day')) : dayjs.utc(asDj.tz().endOf('day'));
    }else{
      console.log("not valid date");
    }
    
    // ready tp update
    if(fldName === 'accessStartDate')
      userObj!.accessStartDate  = asDj?asDj.toISOString():null;
    if(fldName === 'accessEndDate')
      userObj!.accessEndDate    =  asDj?asDj.toISOString():null;

    setInPlaceEditUser(userObj as UserInfo);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  // function onBlurRow(e:any):void{
  //   const userObj = inPlaceEditUser; //easy access 
  //   userObj!.errors.accessStartDate = wdpUtil.validateStartDate (userObj?.accessStartDate?.toString(),userObj?.accessEndDate?.toString());
  //   userObj!.errors.accessEndDate   = wdpUtil.validateEndDate   (userObj?.accessStartDate?.toString(),userObj?.accessEndDate?.toString());
  // }
  /****************************************************************************************
   * Renders a coloured status badge for the Status column
  *****************************************************************************************/
  function renderStatusBadge(status: string | undefined) {
    if (!status) return null;
    const normalized = status.toLowerCase();
    let cssClass = 'status-badge';
    let label = status;
    if (normalized === 'active') {
      cssClass += ' status-active';
      label = 'Active';
    } else if (normalized === 'inactive') {
      cssClass += ' status-inactive';
      label = 'Inactive';
    } else if (normalized === 'softdeleted' || normalized === 'soft deleted') {
      cssClass += ' status-deleted';
      label = 'Deleted';
    }
    return <span className={cssClass}>{label}</span>;
  }
  //////////////////////////////////////////////////////////////////////////////////////////
  const handleToastOpen = (_msg: string, _type: GoabCalloutType = "success") => {
    const notificationType: GoabTemporaryNotificationType = _type === "success" ? "success" : _type === "emergency" ? "failure" : "basic";
    TemporaryNotification.show(_msg, { type: notificationType, duration: "medium" });
  };
  //////////////////////////////////////////////////////////////////////////////////////////
  // html part
  return (
    <div className='users-content'>
      {/************** Title Section *************/}
      <section className='title-section'>
        <h2 className='title'>User maintenance</h2>
        <Link className="link-button" to="/user-ctrl/new"> Create new user +</Link>
      </section>
      
      {/************** search Section *************/}
      <section className='search-section filter-grid'>
        <div data-testid="fltr_userAdminBy">
          {populateDropDown("Username administered by","fltr_userAdminBy",filters.current.userAdminBy,(myAppCtx?.userAdminByList as []).map((x:any)=> ({label:x,value:x})))}
        </div>
        <div data-testid="fltr_userWithRoles">
          {populateDropDown("With roles assigned","fltr_userWithRoles",filters.current.userWithRoles,(myAppCtx?.allRolesList as []).map((x:RoleInfo)=> ({label:x.name,value:x.id})))}
        </div>
        <div data-testid="fltr_localGov">
          {populateDropDown("Local government","fltr_localGov",filters.current.localGov,(myAppCtx?.localGovsList as []).map((x:LookupItemType)=> ({label:x.description,value:x.id})) )}  
        </div>
        <div data-testid="fltr_userStatuses">
          {populateDropDown("Statuses","fltr_userStatuses",filters.current.userStatuses, userStatusOptions)}
        </div>
        <div className='search-section-end'>  
          <SearchBox
            testId='inc-search'
            name='inc-dash-search'
            placeholder="Search by Email, First name, Last name, Display name"
            value={searchStr.current}
            onChange={onSearchInputChange}
            onSearch={onSearchBtn}
            onClose={onCloseSearchBtn}
          >
            {(previewUsersListCount.current !== -1 && previewUsersList.length) ?
              <div className='search-preview-wrap'>
                <GoabTable key="search-preview-table" width="100%" mb="xl">
                  <thead></thead>
                  <tbody >{populatePreviewtableData()}</tbody>
                </GoabTable>
              </div>
              : null
            }
          </SearchBox>
          <div className='clear-all-wrap'>
          <GoabButton testId='ul-clear-all' type="text" size="compact" onClick={() => {onClearAll()}}>Clear all</GoabButton>
          </div>
        </div>
      </section> 
      <section className='search-result-section'>
        {
          populateSearchResTitle()
        }
      </section>
      {/************ Data Table Section ***********/}
      {/* {(!wdpUtil.isNullorUndefined(mainUsersList) && mainUsersList.length) ? */}
      <div>
      <section className="users-table-section users-table ">
        <div className="users-table-inner">
          <GoabTable key={'usersTable'} testId={createTableTestId('usersTable', 'table')} width="100%" mb="xl" onSort={(param: GoabTableOnSortDetail) => sortDataUsers('usersTable',param)}>
            <thead>
              <tr>
                {tableHeaders.map((header, i) => (
                  <th key={`usersTable-header-${i}`} className={header.name !== '' ? `col-${header.name}` : (i === 0 ? 'col-flag' : 'col-actions')} data-testid={createTableTestId('usersTable', 'header', header.name || i)}>
                    {header.name !== '' ?
                      <GoabTableSortHeader name={header.name} direction={header.sortDir ?? 'none'} data-testid={createTableTestId('usersTable', 'sort-header', header.name)}>
                        <span><strong>{header.text}</strong></span>
                      </GoabTableSortHeader>
                      : <span><strong>{header.text}</strong></span>
                    }
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {populatetableData(mainUsersList)}
            </tbody>
          </GoabTable>
        </div>
      </section>
      {(wdpUtil.isNullorUndefined(mainUsersList) !=null && mainUsersList.length > 0) && 
        <GoabBlock alignment="center">
            <GoabBlock mb="m" alignment="center" gap="m">
              <span>Show</span>
              <GoabDropdown testId='ul-pagination-perpage-dropdown' onChange={(details: GoabDropdownOnChangeDetail) => { changePerPage(details.name, details.value) }}  value="20" width="8ch">
                <GoabDropdownItem value="10"></GoabDropdownItem>
                <GoabDropdownItem value="15"></GoabDropdownItem>
                <GoabDropdownItem value="20"></GoabDropdownItem>
                <GoabDropdownItem value="50"></GoabDropdownItem>
                <GoabDropdownItem value="100"></GoabDropdownItem>
              </GoabDropdown>
              <span style={{ whiteSpace: 'nowrap' }}>of {mainUsersListCount.current} items</span>
            </GoabBlock>
            <GoabSpacer hSpacing="fill" />
            <GoabPagination testId='ul-pagination-info'
              variant={'all'}
              itemCount={mainUsersListCount.current}
              perPageCount={perPage.current}
              pageNumber={pageNo.current}
              onChange={(details: GoabPaginationOnChangeDetail) => { OnPaginationChange(details.page) }}
            />
        </GoabBlock>
      }

      </div>

      {/* Circular Progress as a layer  must be child of the page div */}
      {(progressMsg !== "" && (!props.testing)) && <GoabCircularProgress variant="fullscreen" size="large" message={progressMsg} visible={true} />}
    </div>
    
  );

}
export default Users;